require('./app.scss');

// @vendor
const { isEmpty } = require('lodash');
const PropTypes = require('prop-types');
const { addBrowserAnalyticScript } = require('vendor/bugFraud/bugFraud');
const debounce = require('lodash/function/debounce');
const React = require('react');
const { Component } = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');
const classNames = require('classnames');
import { regenerateToken } from 'ok-login';
const { okLoansViews } = require('ok-loans');

// @core
const apiURLBuilder = require('core/apiURLBuilder');
const { cookiesDomain } = require('core/environmentConfig');
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;

// @utilities
import { executeSharedLogin } from 'utilities/loginHelper';
const { getFriendlyName } = require('utilities/initialization');
const storage = require('utilities/storage');
require('utilities/eventStreaming');
import { isFlowMigrationAllowed, isItWebViewPlatform } from '../migrationUsersBranchView/utilities/migration.utils';

// @actions
const chatStatus = require('actions/chat');
const encryptedIPActions = require('actions/getEncryptedIP');
const screenActions = require('actions/screen');
const {isClientWithoutAccountsBeforePG} = require('actions/noClient');

// @components
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');
const Footer = require('components/footer/footer');
const NavbarCC  = require('components/contactCenter/navbarCC/navbarCC');
const Notifications = require('components/commons/notifications/notifications').Notifications;
const VoiceReader = require('components/commons/voiceReader/voiceReader').VoiceReader;
const { Banner } = require('components/broker/brokerBanner/brokerBanner');
const { Header } = require('components/header/header');
const { KeepAliveModal } = require('components/keepAliveModal/keepAliveModal');
const { LogoutModal } = require('components/logoutModal/logoutModal');
import AggregatorAdvicesManager from 'components/aggregator/aggregatorAdvices/aggregatorAdvicesManager/aggregatorAdvicesManager';

// @commons
import { LoadingSection } from 'commonsComponents/loadingSection';
const { Debug } = require('commonsComponents/debug');
const { checkDebugFlags } = require('commonsUtilities/debugHelper');

// @constants
const { TRANSLATION_PLATFORM_PRI, TRANSLATION_PLATFORM_CC } = require('constants/translations');
const { PRODUCTION_ENVIRONMENT } = require('constants/index');
const { GRAY_BACKGROUND } = require('constants/colors');

class App extends Component {
    constructor(props) {
        super(props);

        // uncomment me when mobile and tablet support is re-enabled
        this.resize = this.resize.bind(this);
        this.isMigrationMobile = this.isMigrationMobile.bind(this);
        this.isMigrationSessionModalHybrid = this.isMigrationSessionModalHybrid.bind(this);

        this.onResize = debounce(this.resize, 500);

        if (window.addEventListener) {
            window.addEventListener('resize', this.resize);
        } else {
            window.attachEvent('onresize', this.resize);
        }
        this.resize();

        __CONTACT_CENTER__ && this.loadCC()

        this.referenceElement = React.createRef();
    }

    componentDidMount() {
        const { getEncryptedIP, location } = this.props;
        const query = new URLSearchParams(location.search);
        getEncryptedIP();
        checkDebugFlags(query);
        addBrowserAnalyticScript();
    }

    isFIOCMobile() {
        return (this.props.immInterstitials.getIn(['content', 'flagDocumentacion']) === "1" || this.props.immInterstitials.getIn(['content', 'flagFioc']) === "1") && !this.props.immScreen.get('isDesktop');
    }

    isMigrationMobile() {
        const { immProfile, immMigration } = this.props;
        if (
            immProfile.get('originCountry') &&
            immProfile.get('originCountry') === 'DE' &&
            immMigration.getIn(['fetched']) &&
            isFlowMigrationAllowed(immMigration.getIn(['status']))
        ) {
            return isItWebViewPlatform();
        }
        return false;
    }

    isMigrationSessionModalHybrid() {
       const { immProfile } = this.props;
       return immProfile.get('originCountry')
              && immProfile.get('originCountry') === 'DE'
              && isItWebViewPlatform();
    }

    resize() {
        const { resize } = this.props;
        resize && resize();
    }

    loadCC = () => {
        const {
            location: { pathname },
            history,
            immLogin
        } = this.props;

        const loggedIn = immLogin.get('isAuthenticated');
        const tokenCredential = storage.cookies.get('tokenCredential');

        if ((!loggedIn || !tokenCredential) && pathname && !pathname.includes('disasterRecovery')) {
            let options = {
                nextPathname: pathname,
                containerSelector: '#customLoginContainer',
            }
            executeSharedLogin(options, history);
        }
    }

    buildHeader() {
        const { immLogin, immProfile, location: { pathname }, immGlobalPosition } = this.props;
        const loggedIn = immLogin.get('isAuthenticated');
        const avatar = immProfile.get('avatar');
        const name = getFriendlyName(immProfile);
        const language = getLanguage();

        return(
            <Header
                language={language}
                loggedIn={loggedIn}
                name={name}
                avatar={avatar}
                pathname={pathname}
                hidePrivateBarAndMenu={isClientWithoutAccountsBeforePG() || immGlobalPosition.get('isClientWithoutAccounts')}
            />
        );
    }

    buildFooter() {
        const { immLogin, chatAvailabilityStatusData, immProfile } = this.props;
        const originCountry = immProfile.get('originCountry');
        const isNerudaUser = immProfile.get('isNerudaUser');

        // In case there originCountry is not yet available the footer should not be rendered
        if (!originCountry) return null;

        const loggedIn = immLogin.get('isAuthenticated');
        const chatData = chatAvailabilityStatusData.get('chatAvailabilityStatusData');
        let dataToRender = null;

        if (loggedIn && this.referenceElement.current) {
            const chatStatusData = isEmpty(chatData) ? chatData : chatData.toJS();
            const language = getLanguage();
            dataToRender = (
                <Footer
                    language={language}
                    loggedIn={loggedIn}
                    chatStatus={chatStatusData}
                    isNerudaUser={isNerudaUser}
                    referenceElement={this.referenceElement.current}
                    chatAvailabilityStatus={this.props.chatAvailabilityStatus}
                    rootUrl={apiURLBuilder.getPublicSiteUrl()}
                    originCountry={originCountry}
                    hideFooter={this.isFIOCMobile() || this.isMigrationMobile()}
                />
            );
        }
        return dataToRender;
    }

    regenerateUserToken() {
        if (regenerateToken) {
            regenerateToken({
                url: apiURLBuilder.getURL('regenerateToken'),
                cookiesDomain: cookiesDomain,
                version: 5
            }, undefined, true);
        } else {
            throw "Regenerate Token is not defined."
        }
    }

    render() {
        const { immGlobalPosition, immBanner, immScreen, immProfile, translations, children, logoutModal} = this.props;
        const isClose = immBanner.get('isClose');
        const language = getLanguage();
        const newClass = (!isClose) ? classNames({ '--with-broker-banner': !isClose }) : '';
        const fetchingGlobalPosition = immGlobalPosition.get('isFetching')
                                || (immProfile.get('isFetching') && !immProfile.get('hasBeenFetched'));
        const fetchingTranslations = translations.get(`isFetching${TRANSLATION_PLATFORM_PRI}${language}`)
                                || (__CONTACT_CENTER__ && translations.get(`isFetching${TRANSLATION_PLATFORM_CC}${language}`));

        let domainLanguage = language;
        if (!window.__DEBUG_MODE__) {
            const originArray = location.origin.split('.');
            const countryOriginDomain = originArray[originArray.length - 1];
            domainLanguage = getLanguage(countryOriginDomain);
        }

        const banner = !isClose && <Banner />;
        const header = immScreen.get('headerIsVisible') && !fetchingTranslations ? this.buildHeader() : null;

        let content;
        if (fetchingGlobalPosition || fetchingTranslations) {
            content = (
                <div className="app__spinner">
                    <LoadingSection type="round" width={80} />
                </div>
            );
        } else if ((immGlobalPosition.get('error') || immProfile.get('error'))  && !immProfile.get('isAresUser'))  {
            // If the error was from authorization expired, we don't show any message on the background
            if (immGlobalPosition.getIn(['error', 'status']) !== 401) {
                content = (
                    <div className="app__error">
                        <h1>{formatText("errors-errorBlocker", [], domainLanguage)}</h1>
                    </div>
                );
            }
        } else if ((immGlobalPosition.get('error') || immProfile.get('error')) && immProfile.get('isAresUser'))  {
            // If the error was from globalposition failure for ARES user
            if (immGlobalPosition.getIn(['error', 'status']) !== 401) {
                content = (
                    <div >
                        <okLoansViews.loansForAresTypeUserView></okLoansViews.loansForAresTypeUserView>
                    </div>
                );
            }
        } else if (logoutModal.get('isOpen') || logoutModal.get('showBlank')) {
            content = <div style={{width: '100%', height: '100%', backgroundColor: GRAY_BACKGROUND}} />
        } else {
            content = [
                children,
                <AggregatorAdvicesManager key="aggregatorAdvicesManager"/>
            ];
        }


        const footer = immScreen.get('footerIsVisible') ? this.buildFooter() : null;

        return (
            <div className="app__container">
                { window.__ENV__ !== PRODUCTION_ENVIRONMENT && <Debug /> }
                <div className={`${this.isMigrationMobile() ? 'app__outer--migration' : immScreen.get('footerIsVisible') ? `app__outer${newClass}` : ''}`}>
                    <LogoutModal
                        message="login-loginExpired"
                        acceptText="login-loginExpiredRetry"
                        domainLanguage={domainLanguage}
                        isFIOCMobile={this.isFIOCMobile()}
                        isMigrationMobile={this.isMigrationSessionModalHybrid()}
                    />
                    <KeepAliveModal isFIOCMobile={this.isFIOCMobile()} isMigrationMobile={this.isMigrationSessionModalHybrid()}/>
                    <div className="app__block-landscape"></div>
                    <div className="app__modal">
                        <FormattedText value="common-rotateYourDevice" format="firstUppercase" />
                    </div>
                    <div
                        ref={this.referenceElement}
                        className={`app__content ${
                        this.isFIOCMobile() || this.isMigrationMobile()
                            ? this.isFIOCMobile()
                            ? 'app__content-fioc-mobile'
                            : 'app__content-migration-mobile'
                            : ''
                        }`}
                    >
                        {banner}
                        {header}
                        <ContactCenterRender>
                            <NavbarCC url={location.pathname} />
                        </ContactCenterRender>
                        <div className="app__content-detail">
                            {content}
                        </div>
                        <Notifications />
                    </div>
                    <VoiceReader />
                </div>
                {footer}
            </div>
        );
    }
}

App.propTypes = {
    chatAvailabilityStatusData: PropTypes.object,
    chatAvailabilityStatus:PropTypes.func,
    children: PropTypes.any,
    getEncryptedIP: PropTypes.func.isRequired,
    immLogin: PropTypes.object.isRequired,
    immScreen: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immGlobalPosition: PropTypes.object.isRequired,
    translations: PropTypes.object.isRequired,
    immBanner: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    resize: PropTypes.func.isRequired,
    immAggregatorData: PropTypes.object.isRequired,
    logoutModal: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
};

module.exports.constructor = App;
module.exports.App = connect(
    state => ({
        chatAvailabilityStatusData: state.okChat,
        immLogin: state.okLogin,
        immProfile: state.profile,
        immScreen: state.screen,
        immGlobalPosition: state.globalPosition,
        immBanner: state.bannerUpdate,
        immAggregatorData: state.aggregatorData,
        immInterstitials: state.interstitialGeneric,
        immMigration: state.migration,
        translations : state.translations,
        logoutModal : state.logout,
    }), {
        chatAvailabilityStatus: chatStatus.chatAvailabilityStatus,
        getEncryptedIP: encryptedIPActions.getEncryptedIP,
        resize: screenActions.resize,
    }
)(withRouter(App));
